import lodashRange from 'lodash/range';
import lodashRangeRight from 'lodash/rangeRight';

/**
 * Create an array of numbers (positive and/or negative) progressing from start up to, but not including, end.
 * If the end is lower than the start, this function returns an empty array.
 */
export function rangeLeft(start: number, end: number, step: number = 1): number[] {
    if (start <= end) {
        return lodashRange(start, end, step);
    }
    return [];
}

/**
 * Create an array of numbers (positive and/or negative) progressing from start up to, but not including, end.
 * If the end is greater than the start, this function returns an empty array.
 */
export function rangeRight(start: number, end: number, step: number = 1): number[] {
    if (start >= end) {
        return lodashRangeRight(start, end, step);
    }
    return [];
}
